export default __webpack_public_path__ + "static/media/partner-large.10ef6f22.svg";